import { _getItemFromLocalDecrypted } from "network-helper";
import _ from "lodash";

import { _getPartnerIds } from "./Network/partnerOnBoarding";

export const _isCorporateLinked = async () => {
  try {
      const currentProfile = _getItemFromLocalDecrypted("_cp");
      const currentProfileDetails = JSON.parse(currentProfile);
  
      let jhhId = currentProfileDetails.jio_id;
      const dataObj = {
          user_jio_id: jhhId,
      };
      
      const response = await _getPartnerIds(dataObj);
      const result = _.get(response, "contents", []);
  
      let corporateDetails = {linked: false, partner: undefined}

      result.forEach((item: any) => {
          const partnerType = _.get(item, "partner.type", "");
          if(partnerType === "corporate") {
              corporateDetails = {linked: true, partner: item}
          }
      })
      return corporateDetails
  } catch (error) {
      return {linked: false}
  }
}